// Select2 initialization for admin pages
import $ from 'jquery';
import 'select2';
import 'select2/dist/css/select2.css';

// Initialize Select2 on admin multi-select fields
document.addEventListener('DOMContentLoaded', function() {
  if (typeof $ === 'undefined' || !$.fn.select2) return;

  // Authors on posts
  $('.author-multiselect-select').each(function() {
    if (!$(this).data('select2')) {
      $(this).select2({
        placeholder: 'Select authors...',
        allowClear: false,
        width: '100%'
      });
    }
  });

  // Resources on posts
  $('.resource-multiselect-select').each(function() {
    if (!$(this).data('select2')) {
      $(this).select2({
        placeholder: 'Select resources...',
        allowClear: true,
        width: '100%'
      });
    }
  });

  // Posts on resources
  $('.post-multiselect-select').each(function() {
    if (!$(this).data('select2')) {
      $(this).select2({
        placeholder: 'Select posts...',
        allowClear: true,
        width: '100%'
      });
    }
  });

  // Tags (posts + announcements)
  $('.tag-multiselect-select').each(function() {
    if (!$(this).data('select2')) {
      $(this).select2({
        placeholder: 'Select tags...',
        allowClear: true,
        width: '100%'
      });
    }
  });

  // Tags filter (sidebar filters): searchable multi-select
  $('.tag-filter-select').each(function() {
    if (!$(this).data('select2')) {
      $(this).select2({
        placeholder: 'Filter by tags...',
        allowClear: true,
        width: '100%'
      });
    }
  });
});

export default {};

